import { ui } from '@libs/domain';
import { useItemNames } from '@ps-smart-cp/ppfw-client';
import { type ChangeEvent, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  FormSection,
  LoginContainer,
  LoginInputField,
  StyledLoginButton,
  mfaChallenge,
} from '../features/login';
import { useTryShell } from '../hooks';

interface UserState {
  email: string;
  session: string;
}

export function AdminMfaVerify() {
  const navigate = useNavigate();
  const location = useLocation();
  const { tryRequest, error, setError } = useTryShell();

  const userState = location.state as UserState;
  const [verificationCode, setVerificationCode] = useState('');

  const titleNames = useItemNames(ui.titleNames);
  const labelNames = useItemNames(ui.labelNames);
  const buttonNames = useItemNames(ui.buttonNames);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => setVerificationCode(e.currentTarget.value);

  useEffect(() => {
    if (!userState) {
      navigate('/admin-login', { replace: true });
      return;
    }
  }, []);

  // TODO: AUTH-333 エラーメッセージのローカライズ
  const onVerify = async () =>
    await tryRequest(async () => {
      if (verificationCode === '' || verificationCode.length !== 6) {
        setError('【ログインエラー】認証コードは6桁の数字を入力してください。(EFW56022)');
        return;
      }

      await mfaChallenge(userState.email, userState.session, verificationCode);

      navigate('/system-management/main-menu', { replace: true });
    });

  return (
    <LoginContainer title={titleNames('mfaVerification')} error={error}>
      <p style={{ fontSize: 13 }}>{labelNames('enterVerificationCode')}</p>
      <FormSection>
        <LoginInputField
          id="verification-code"
          name="verificationCode"
          label={`${labelNames('verificationCode')}*`}
          value={verificationCode}
          onChange={onChange}
          onEnter={onVerify}
          type="text"
        />
      </FormSection>
      <FormSection>
        <StyledLoginButton id="verify-btn" displayName={buttonNames('post')} onClick={onVerify} />
        <StyledLoginButton
          id="return-btn"
          displayName={buttonNames('return')}
          onClick={() => navigate('/admin-login')}
        />
      </FormSection>
    </LoginContainer>
  );
}
